import React from "react";
import { Snackbar } from "@mui/material";
import * as Styled from "../../styles";
import type { ConfigMode } from "../../Context/types";
import CancelProviderModal from "../CancelProviderModal";
import ConfirmSaveModal from "../ConfirmSaveModal";
import DeleteProviderModal from "../DeleteProviderModal";
import ProviderAdditionalStepModal from "../ProviderAdditionalStepModal";
import type { ProviderAdditionalStep } from "services/paymentApi.types";

interface ProviderModalsProps {
  mode: ConfigMode;
  showCancelProvider: boolean;
  showValidationError: boolean;
  showDeleteProvider: boolean;
  showSuccessMessage: boolean;
  showConfirmSave: boolean;
  additionalStep: ProviderAdditionalStep | null;
  isDeleting: boolean;
  isSaving: boolean;
  onCancelProvider: () => void;
  onCloseValidationError: () => void;
  onCloseDeleteModal: () => void;
  onCloseSuccessMessage: () => void;
  onCloseConfirmSave: () => void;
  onConfirmDelete: () => void;
  onConfirmSave: () => void;
  onCloseAdditionalStepModal: () => void;
  onCancel?: () => void;
}

function ProviderModals({
  mode,
  showCancelProvider,
  showValidationError,
  showDeleteProvider,
  showSuccessMessage,
  showConfirmSave,
  additionalStep,
  isDeleting,
  isSaving,
  onCancelProvider,
  onCloseValidationError,
  onCloseDeleteModal,
  onCloseSuccessMessage,
  onCloseConfirmSave,
  onConfirmDelete,
  onConfirmSave,
  onCloseAdditionalStepModal,
  onCancel,
}: ProviderModalsProps) {
  return (
    <>
      {showCancelProvider && (
        <CancelProviderModal
          open={showCancelProvider}
          onClose={onCancelProvider}
          onConfirm={onCancel || onCancelProvider}
          mode={mode}
        />
      )}
      <Snackbar
        open={showValidationError}
        autoHideDuration={6000}
        onClose={onCloseValidationError}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Styled.AlertStyled onClose={onCloseValidationError} severity="error">
          Existem erros nos formulários. Verifique as abas com ícones de aviso e
          corrija os campos obrigatórios.
        </Styled.AlertStyled>
      </Snackbar>

      {additionalStep && (
        <ProviderAdditionalStepModal
          open={Boolean(additionalStep)}
          additionalStep={additionalStep}
          onClose={onCloseAdditionalStepModal}
        />
      )}

      {showConfirmSave && (
        <ConfirmSaveModal
          open={showConfirmSave}
          onClose={onCloseConfirmSave}
          onConfirm={onConfirmSave}
          isSaving={isSaving}
          mode={mode}
        />
      )}

      {showDeleteProvider && (
        <DeleteProviderModal
          open={showDeleteProvider}
          onClose={onCloseDeleteModal}
          onConfirm={onConfirmDelete}
          isDeleting={isDeleting}
        />
      )}
      <Snackbar
        open={showSuccessMessage}
        autoHideDuration={1500}
        onClose={onCloseSuccessMessage}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Styled.AlertStyled onClose={onCloseSuccessMessage} severity="success">
          Provedor de pagamento criado com sucesso!
        </Styled.AlertStyled>
      </Snackbar>
    </>
  );
}

export default ProviderModals;
